export const HelpButtonTestIds = {
  OPEN_MENU: 'help.open-menu-button',
  MESSENGER_ITEM: 'help.messenger-menu-item',
  TICKETS_PORTAL_ITEM: 'help.tickets-portal-menu-item',
};
